<template>
<div class="icon">
    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="63" height="74"
    viewBox="0 0 63 74">
    <defs>
    <filter id="a" width="119.4%" height="119.4%" x="-9.7%" y="-9.7%" filterUnits="objectBoundingBox">
        <feOffset in="SourceAlpha" result="shadowOffsetOuter1"/>
        <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="2"/>
        <feColorMatrix in="shadowBlurOuter1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"/>
    </filter>
    </defs>
    <g fill="none" fill-rule="evenodd" transform="scale(1 -1) rotate(-45 -329.673 1664.232)">
    <use fill="#000" filter="url(#a)" xlink:href="#b"/>
    <path id="b" fill="currentColor" d="M1132.737 674L1148 736l-62-15.263z"/>
    </g>
    </svg>
</div>
</template>

<script setup>
</script>